module.exports = __webpack_public_path__ + "img/1557614071234240513.b8d42c6c.png";